import { takeLatest, put, call } from 'redux-saga/effects';
import { createAnimation, getAnimations, getAnimationDetails, editAnimation, deleteAnimation } from '../../network/apis/animations';
import {
  createAnimationRequest,
  getAnimationsRequest,
  getAnimationsResponse,
  getAnimationDetailsRequest,
  getAnimationDetailsResponse,
  editAnimationRequest,
  deleteAnimationRequest,
  updateActiveStatus,
} from './slice';
import { showSnackMsg } from "../../utils/Helpers";
import { setSkeletonObject, setCanShowEmptyState, clearSkeletonObject } from "../Loader/slice";
import { ROUTES_PATHS } from '../../utils/RoutesPaths';

function* getAnimationsSaga({ payload }) {
  try {
    yield put(getAnimationsResponse({ animations: [], meta: {} }));
    yield put(setSkeletonObject({ field: "animations", value: true }));
    const response = yield call(getAnimations, payload);
    const meta = {
      currentPage: +response.headers["current-page"],
      count: +response.headers["total-count"],
      pages: +response.headers["total-pages"],
    };
    const animations = response.data?.public_event_animations;
    yield put(getAnimationsResponse({ animations, meta }));
    yield put(setSkeletonObject({ field: "animations", value: false }));
    if (animations.length === 0) {
      yield put(setCanShowEmptyState(true));
    } else {
      yield put(setCanShowEmptyState(false));
    }
  } catch (err) {
    yield put(setSkeletonObject({ field: "animations", value: false }));
    yield put(setCanShowEmptyState(true));
    yield showSnackMsg(err.response?.data?.message);
  }
}

function* getAnimationDetailsSaga({ payload }) {
  try {
    const { id, isEdit } = payload;
    yield put(setSkeletonObject({ field: "animations", value: true }));
    if (!!isEdit) {
      // show loader if edit animation mode
      yield put(clearSkeletonObject());
    }
    const response = yield call(getAnimationDetails, id);
    const animation = response.data?.public_event_animation;
    yield put(getAnimationDetailsResponse(animation));
    yield put(setSkeletonObject({ field: "animations", value: false }));
    if (!animation) {
      yield put(setCanShowEmptyState(true));
    } else {
      yield put(setCanShowEmptyState(false));
    }
  } catch (err) {
    yield put(setSkeletonObject({ field: "animations", value: false }));
    yield put(setCanShowEmptyState(true));
    yield showSnackMsg(err.response?.data?.message);
  }
}

function* createAnimationSaga({ payload }) {
  try {
    const { data, navigate, successMsg } = payload;
    yield call(createAnimation, data);
    yield navigate(ROUTES_PATHS.animations);
    yield put(showSnackMsg(successMsg, "success"));
  } catch (err) {
    yield showSnackMsg(err.response?.data?.message);
  }
}

function* editAnimationSaga({ payload }) {
  try {
    const { id, data, navigate, successMsg } = payload;
    yield call(editAnimation, { id, data });
    yield showSnackMsg(successMsg, "success");
    if (!!navigate) {
      yield navigate(ROUTES_PATHS.animations);
    } else {
      yield put(getAnimationsRequest());
    }
  } catch (err) {
    yield showSnackMsg(err.response?.data?.message);
  }
}

function* deleteAnimationSaga({ payload }) {
  try {
    const { id, successMsg, navigate } = payload;
    yield call(deleteAnimation, id);
    yield showSnackMsg(successMsg, "success");
    if (navigate) {
      yield navigate(ROUTES_PATHS.animations);
    } else {
      yield put(getAnimationsRequest());
    }
  } catch (err) {
    yield showSnackMsg(err.response?.data?.message);
  }
}


function* updateActiveStatusSaga({ payload }) {
  try {
    const { id, data, successMsg } = payload;
    yield call(editAnimation, { id, data });
    yield showSnackMsg(successMsg, "success");
    yield put(getAnimationDetailsRequest({ id }));
  } catch (err) {
    yield showSnackMsg(err.response?.data?.message);
  }
}

export default function* animationsSaga() {
  yield takeLatest(createAnimationRequest.type, createAnimationSaga);
  yield takeLatest(getAnimationsRequest.type, getAnimationsSaga);
  yield takeLatest(getAnimationDetailsRequest.type, getAnimationDetailsSaga);
  yield takeLatest(editAnimationRequest.type, editAnimationSaga);
  yield takeLatest(deleteAnimationRequest.type, deleteAnimationSaga);
  yield takeLatest(updateActiveStatus.type, updateActiveStatusSaga);
} 